// Important: Are you changing values? Update values in MediaQuery.scss as well
export const mobileEnd = 767;
export const tabletStart = mobileEnd + 1;
export const tabletEnd = 992;
export const desktopStart = tabletEnd + 1;
